import { Alert as MantineAlert, AlertProps } from '@mantine/core';

export type IAlertProps = AlertProps;

/** @registry Design-layer pass-through over Mantine Alert; import this instead of @mantine/core Alert outside src/design. */
export const Alert = MantineAlert;
